import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  computed,
  effect,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { GameListItem, NewTagGameList, ProviderInterface } from '../../interfaces/game.interface.js';
import { ImgCarouselOptions } from '../img-carousel/img-carousel-options.interface.js';

@UntilDestroy()
@Component({
  selector: 'app-new-swiper-unit',
  templateUrl: './new-swiper-unit.component.html',
  styleUrls: ['./new-swiper-unit.component.scss'],
  host: {
    '[class.hide-when-no-data]': 'hideOnNoData && !loading && !hasData()',
  },
})
export class NewSwiperUnitComponent implements OnInit, OnChanges {
  constructor(
    private appService: AppService,
    private router: Router,
  ) {
    effect(() => {
      const gameData = this._gameData();
      const assignUrl = this._assignUrl();
      const providersData = this._providersData();
      this.url = this.getUrl(gameData, assignUrl, providersData);
    });
  }

  domain = window.location.origin;
  /**板块标题 */
  @Input() title?: string = '';

  /**在没数据的时候是否隐藏 */
  @Input() hideOnNoData: boolean = false;

  /**在没数据的时候是否隐藏滚动的部分（保留标题） */
  // @Input() hideCarouselOnNoData: boolean = false;

  /**数据准备中, 如果使用 hideOnNoData或hideCarouselOnNoData 时候必须传，否则会失去骨架效果 */
  @Input() loading: boolean = false;

  /**用于显示什么类型 */
  @Input() for: 'game' | 'provider' | 'label' | 'sport' = 'game';
  _for = signal(this.for);

  /**遍历的数据 - 游戏 */
  @Input() gameData?: unknown[];
  _gameData = signal(this.gameData);

  /**遍历的数据 - 厂商 */
  @Input() providersData?: ProviderInterface[];
  _providersData = signal(this.providersData);

  /**遍历的数据 - 标签 */
  @Input() labelsData?: NewTagGameList[];
  _labelsData = signal(this.labelsData);

  /**遍历的数据 - 游戏 */
  @Input() sportData?: unknown[];
  _sportData = signal(this.sportData);

  @Input() gameList?: GameListItem[] = [];

  /**是否是用于显示厂商logo */
  @Input() isProvider: boolean = false;

  /**是否显示更多按钮 */
  showMore = computed(() => {
    switch (this._for()) {
      case 'game':
        return !!this._assignUrl();
      case 'provider':
        return true;
      case 'label':
        return false;
      default:
        return false;
    }
  });

  /**渲染的数据 */
  renderData = computed(() => {
    const gdata = this._gameData();
    const pdata = this._providersData();
    const ldata = this._labelsData();
    const sdata = this._sportData();
    // 防止接口问题返回太多卡死，截取最多一百个
    if (gdata && gdata.length > 0) return gdata.slice(0, 100);
    if (pdata && pdata.length > 0) return pdata;
    if (ldata && ldata.length > 0) return ldata;
    if (sdata && sdata.length > 0) return sdata;
    return Array(8).fill(null);
  });

  /**是否有真实数据 */
  hasData = computed(() => {
    return !!this.renderData()[0];
  });

  /** 后台配置 后的 游戏标签跳转 */
  @Input() assignUrl: string = '';
  _assignUrl = signal(this.assignUrl);

  /**滚动与断点配置 */
  @Input() imgCarouselConfig: ImgCarouselOptions = {
    slidesPerView: 8,
    slidesPerGroup: 8,
    spaceBetween: 20,
    speed: 500,
    breakpoints: {
      1400: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 20,
      },
      1090: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 20,
      },
      890: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
      },
      690: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 6,
      },
    },
  };

  /**点击卡片 */
  @Output() clickItem: EventEmitter<unknown> = new EventEmitter();

  /**点击卡片之后 */
  @Output() afterClickItem: EventEmitter<unknown> = new EventEmitter();

  url: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.gameData) this._gameData.set(changes.gameData.currentValue);
    if (changes.providersData) this._providersData.set(changes.providersData.currentValue);
    if (changes.labelsData) this._labelsData.set(changes.labelsData.currentValue);
    if (changes.sportData) this._sportData.set(changes.sportData.currentValue);
    if (changes.for) this._for.set(changes.for.currentValue);
    if (changes.assignUrl) this._assignUrl.set(changes.assignUrl.currentValue);
  }

  ngOnInit() {}

  getUrl(gameData: unknown[] | undefined, assignUrl: string, providersData?: ProviderInterface[]): string {
    if (gameData) {
      if (!assignUrl) return '';
      return `${this.appService.languageCode}/${this.assignUrl}`;
    } else if (providersData) {
      return `${this.appService.languageCode}/casino/provider`;
    }
    return '';
  }

  /** 标题、更多的跳转 */
  turn() {
    if (!this.url) return;
    this.router.navigateByUrl(this.url);
  }
}
